import React, { useRef } from 'react'
import './PopupMessage.css'

// Icons
import { MdOutlineClose } from "react-icons/md";

import Icon01 from '../../assets/TGG_Icon_Color_01.png'
import Icon02 from '../../assets/TGG_Icon_Color_02.png'
import Icon03 from '../../assets/TGG_Icon_Color_03.png'
import Icon04 from '../../assets/TGG_Icon_Color_04.png'
import Icon05 from '../../assets/TGG_Icon_Color_05.png'
import Icon06 from '../../assets/TGG_Icon_Color_06.png'
import Icon07 from '../../assets/TGG_Icon_Color_07.png'
import Icon08 from '../../assets/TGG_Icon_Color_08.png'
import Icon09 from '../../assets/TGG_Icon_Color_09.png'
import Icon10 from '../../assets/TGG_Icon_Color_10.png'
import Icon11 from '../../assets/TGG_Icon_Color_11.png'
import Icon12 from '../../assets/TGG_Icon_Color_12.png'
import Icon13 from '../../assets/TGG_Icon_Color_13.png'
import Icon14 from '../../assets/TGG_Icon_Color_14.png'
import Icon15 from '../../assets/TGG_Icon_Color_15.png'
import Icon16 from '../../assets/TGG_Icon_Color_16.png'
import Icon17 from '../../assets/TGG_Icon_Color_17.png'

function PopupMessage({ popUpState, setPopUpState }) {

    const images = [
        Icon01,
        Icon02,
        Icon03,
        Icon04,
        Icon05,
        Icon06,
        Icon07,
        Icon08,
        Icon09,
        Icon10,
        Icon11,
        Icon12,
        Icon13,
        Icon14,
        Icon15,
        Icon16,
        Icon17
    ]


    const messageBox = useRef(null);
    const closeMessage = (e) => {
        if (e.target === messageBox.current) {
            setPopUpState(false);
        }
    }

    const closeMessageByBtn = () => {
        setPopUpState(false)
    }

    return (
        <div className={`message-box ${popUpState ? '' : 'hide'}`} ref={messageBox} onClick={closeMessage}>
            <div className='road-map-messages'>
                <div className="road-map-messages-header">
                    <div className="road-map-message-title">
                        <h3>OUR FUTURE FIRST JOURNEY</h3>
                    </div>
                    <div className="road-map-message-icon">
                        <MdOutlineClose size={30} onClick={closeMessageByBtn} />
                    </div>
                </div>
                <center>
                    <div className="road-map-message-contents">
                        <div className="road-map-message-contents-p">
                            <p>
                                Sustainability at Hirdaramani has always been a continuous and deliberate journey, built on our long-standing commitment to responsible business practices, our people and the communities we operate in.
                            </p>
                            <p>
                                The Future First Roadmap 2025 was developed as a structured approach to guide this journey, bringing together our responsibilities into a clear and measurable plan. It defines how we set priorities, take action and track progress across our sustainability agenda.
                            </p>
                            <p>
                                Built on four core pillars; <i>Conserve our Environment, Empower our Associates, Support our Communities and Trust in Good Choices</i> the roadmap outlines our key focus areas, targets and the actions required to deliver meaningful outcomes.
                            </p>
                            <p>
                                As we build on this foundation, Future First 2.0 takes this commitment forward with greater focus and integration. Our Environmental Sustainability Roadmap advances climate action, circularity, responsible consumption and biodiversity protection, while our Social Sustainability Roadmap, guided by the W.E.A.V.E. framework focuses on empowering our people and supporting our communities.
                            </p>
                            <p>
                                At its core, Future First is about creating measurable impact ensuring that our efforts contribute to long-term value for our business, society and future generations. Together, Future First 2.0 will continue to drive meaningful, long-term impact across our global footprint for our people, our communities and our planet.
                            </p>
                        </div>

                        <div className='SustainabilityReport-image-grid-container'>
                            {
                                images.map((image, i) => (
                                    <div key={i}>
                                        <img src={image} alt="" />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </center>

            </div>
        </div>
    )
}

export default PopupMessage
